const p9 = {
    validate: {
        notRequired: v => !v || !!v,
        required: v => !!v || 'Veuillez remplir ce champs.',
        secret: v => !!v  ? p9.str.strongRegex.test( v ) || `Un mot de passe valide doit compter 8 caractères ou plus dont au moins un
        de chacune des catégories suivantes: chiffres, lettres majuscules, lettres minuscules, caractères spéciaux ( !@#$%^&* )` : true,
        fullName: v => !!v  ? /[A-z-']+\s[A-z-'\s]+/.test( v ) || 'Entrez un nom complet valide.' : true,
        name: v => !!v  ? /[\D-'\s]+/.test( v ) || 'Entrez un nom valide.' : true,
        email: v => !!v ? /^[A-z0-9-_\.]+@[A-z0-9-_\.]+[.][A-z0-9]+$/.test( v ) || 'Entrez un courriel valide.' : true,
        phone: v => !!v  ? /^\d{10}$/.test(v.replace(/^1/, '').replace(/[^\d]/g, '')) || 'Entrez un numéro de téléphone valide.' : true,
        address: v => !!v  ? /^[\D\d-'\s]{5,}$/.test( v ) || 'Entrez une adresse valide.' : true,
        postalCode: v => !!v  ? /^[A-z][0-9][A-z][0-9][A-z][0-9]$/.test(v.replace(/[^0-9A-z]/g, '')) || 'Entrez un code postal valide.' : true,
        sin: v => !!v  ? /^[0-9]{9}$/.test(v.replace(/[^0-9]/g, '')) || `Entrez un numéro d'assurance sociale valide.` : true,
        text: v => !!v  ? /[\D\d]*/.test( v ) || 'Utilisez des caractères valides.' : true,
        message: v => !!v  ? v.length >= 20 || 'Entrez un message de plus de 20 caractères.' : true,
        ramq: v => !!v  ? v && /^[A-Z]{4}[0-9]{8}$/.test(p9.parse.alphanumeric( v ).toUpperCase()) || `Numéro d'assurance maladie invalide` : true,
    },
    parse: {
        numeric( str ) {
            return str.replace(/[^0-9]/g, '')
        },
        alpha( str ) {
            return str.replace(/[^A-Za-z\u0300-\u036f]/g, '')
        },
        alphanumeric( str ) {
            return str.replace(/[^A-Za-z0-9]/g, '')
        },
        name( str ) {
            return str.toLowerCase().replace(/(^|\s|-)(\w)/g, x => {
                return x.toUpperCase()
            })
        },
        email( str ) {
            return /[\.A-z0-9_-]{2,}@[A-z0-9_-]{2,}\.[\.A-z0-9]{2,5}/.test( str ) ? str : null
        },
        phone( str ) {
            str = !!str ? p9.parse.numeric(str.replace(/^1/, '')) : null
            return !!str && /[0-9]{10}/.test( str ) ? `(${str.substring(0, 3)}) ${str.substring(3, 6)}-${str.substring(6, 10)}` : null
        },
        postal( str ) {
            let test = new RegExp( "[A-z][0-9][A-z][0-9][A-z][0-9]" )

            str = str.toUpperCase().replace(/[^0-9A-Z]/g, '')
            str = test.test( str ) ? `${str.substring(0, 3)} ${str.substring(3, 6)}` : null

            return !!str ? str : null
        },
        text( str ) {
            str = str.replace(/[^\D\d]/g, '')
            str = str.replace(/\s{2,}/, ' ')
            return str.replace(/[^\D\d]/g, '')
        },
        sin( str ) {
            str = p9.parse.numeric(str.replace(/[^0-9]/, ''))
            return /[0-9]{9}/.test( str ) ? `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(6, 9)}` : null
        },
        ramq( str ) {
            str = p9.parse.alphanumeric( str ).toUpperCase()
            return /[A-Z]{4}[0-9]{8}/.test( str ) ? str : null
        },
        float( str ) {
            return Number(typeof str === 'string'? str.replace(/[^\d\.]/gi, '') : str)
        },
        money( str ) {
            return `${ parseFloat(p9.parse.float( str )).toFixed( 2 ) } $`
        },
    },
    str: {
        strongRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"),//"),
        mediumRegex: new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"),
        capitalize( str ) {
            return str.charAt( 0 ).toUpperCase() + str.toLowerCase().slice( 1 )
        },
        isVowel( str ) {
            let vowels = ['a', 'e', 'i', 'o', 'u', 'y']
            str = str.substring( 0,1 )
            return vowels.includes(p9.str.removeAccents( str ))
        },
        removeAccents( str ) {
            return str.normalize( "NFD" ).replace(/[\u0300-\u036f]/g, "")
        },
        comparableString( str ) {
            return !!str  ? p9.str.removeAccents(str.toString().toUpperCase().trim()) : null
        },                
        uid( len ) {   
            let uid = '', num = len || 25;               
            let IDX = 36, HEX = '';
            while ( IDX-- ) HEX += IDX.toString( 36 );
            while ( num-- ) uid += HEX[Math.random() * 36 | 0];
            return uid;
        },
        sensitive(val, last) {
            if( !!val ) {
                let i = 0
                let str = ''
                let escape = new RegExp( /[\s-\.]/ )
                last = val.replace(/[\s-\.]/g, '').length - last

                for(let c in val) {
                    str = str + (i < last && !escape.test( val[c] ) ? '*' : val[c])
                    if(!escape.test( val[c] )) i++
                }

                val = str
            }
            
            return val
        },
    },
    test: {
        isUrl( string ) {
            try {
                return Boolean(new URL( string ))
            } catch ( e ) {
                return false
            }
        },
    },
    dates: {
        dateTranslator( val ) {
            return val.replace( /[Jj][Aa][Nn][A-z\.]*/g,'Janvier' ).replace( /[Ff][Ee][Bb][A-z\.]*/g,'Février' ).replace( /[Mm][Aa][Rr][A-z\.]*/g,'Mars' ).replace( /[Aa][Pp][Rr][A-z\.]*/g,'Avril' ).replace( /[Mm][Aa][Yy][A-z\.]*/g,'Mai' ).replace( /[Jj][Uu][Nn][A-z\.]*/g,'Juin' ).replace( /[Jj][Uu][Ll][A-z\.]*/g,'Juillet' ).replace( /[Aa][Uu][Gg][A-z\.]*/g,'Août' ).replace( /[Ss][Ee][Pp][A-z\.]*/g,'Septembre' ).replace( /[Oo][Cc][Tt][A-z\.]*/g,'Octobre' ).replace( /[Nn][Oo][Vv][A-z\.]*/g,'Novembre' ).replace( /[Dd][Ee][Cc][A-z\.]*/g,'Décembre' );
        },
        buildRecurrentDate( val ) {
            return new Date(p9.dates.addCurrentYear( val ))
        },
        isExpired( date ) { return new Date().toISOString().split( 'T' )[0] > date },
        addCurrentYear( str ) { 
            let parts = str.split( '-' )

            for(let part in parts) {
                parts[part] = /^[0-9]$/.test( parts[part] ) ? `0${ parts[part] }` : parts[part]
            }

            /* parts[1] = String(Number( parts[1] ) + 1) */

            return `${new Date().getFullYear()}-${ parts.join( '-' ) }` 
        },
        mostRecent( array, prop ) {
            return array.sort( ( d1, d2 ) => d2[ prop ] > d1[ prop ] ? 1 : -1 )[ 0 ]
        },
        compare(date1, date2){
            if (date1 > date2) return ( 1 );
            else if (date1 < date2) return ( -1 );
            else return ( 0 ); 
        },
        math(date, level, operator) {
            let ref = new Date( date )
            ref[`set${ level }`](ref[`get${ level }`]() + Number( operator ))
            return ref.toISOString().split( 'T' )[0]
        },
        getAge( birthday ) {
            birthday = new Date( birthday )
            var diff_ms = Date.now() - birthday.getTime();
            var age_dt = new Date( diff_ms ); 
          
            return Math.abs(age_dt.getUTCFullYear() - 1970);
        },
        getAgeAtDate(birthday, ref) {
            birthday = new Date( birthday )
            var diff_ms = new Date( ref ) - birthday.getTime();
            var age_dt = new Date( diff_ms ); 
          
            return Math.abs(age_dt.getUTCFullYear() - 1970);
        },
        toFrench( isoDateString ) {
            const months = [
                'janvier',
                'février',
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                'août',
                'septembre',
                'octobre',
                'novembre',
                'décembre',
            ]

            let parts = isoDateString.split( '-' )

            return `${ parts[2] } ${ months[ Number( parts[1] ) - 1 ] } ${ parts[0] }`
        },
    },
    arrays: {
        sum( items ) {
            return items.reduce((a, b) => {
                return a + p9.parse.float( b )
            }, 0)
        },
        listSum(items, prop){
            return items.reduce((a, b) => {
                return a + p9.parse.float( b[prop] )
            }, 0)
        },
        singleOccurrence( arr ) {
            return arr.filter(i => arr.filter(j => i === j).length === 1)
        },
    },
    objects: {
        incMapping(obj, incProps) {
            return Object.fromEntries(Object.entries( obj ).filter(([k, v]) => incProps.indexOf( k ) > -1))
        },
        excMapping(obj, excProps) {
            return Object.fromEntries(Object.entries( obj ).filter(([k, v]) => excProps.indexOf( k ) === -1))
        },
        sortList(list, prop, order) {
            return list.sort(p9.objects.compareValues(prop, order))
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                a = Array.isArray( a ) ? a[1] : a
                b = Array.isArray( b ) ? b[1] : b

            if (!a.hasOwnProperty( key ) || !b.hasOwnProperty( key )) return 0
            const comparison = a[key].localeCompare( b[key] )
        
            return (
                (order === 'desc') ? (comparison * -1) : comparison
            )
            }
        },
    },
}

export default {
    install(Vue, options) {
        Vue.prototype.$p9 = p9
    }
}